/**
 * Format an ISO timestamp as a short relative time string (e.g. "3h ago").
 * Falls back to a locale date for anything older than ~a week.
 */
export function formatRelativeTime(timestamp) {
  if (!timestamp) return '';

  const then = new Date(timestamp);
  if (isNaN(then.getTime())) return '';

  const diffMs = Date.now() - then.getTime();
  const diffSec = Math.round(diffMs / 1000);

  if (diffSec < 0) return 'just now';
  if (diffSec < 45) return 'just now';

  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;

  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;

  const diffDay = Math.round(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;

  return then.toLocaleDateString();
}
